export enum SignalingEndpoint {
  DEV0 = 'wss://network-audit-echo.gke1-west4.wsf-dev-0.wstack.net/ws',
  PROD1 = 'wss://network-audit-echo.gke1-west3.wsf-prod-1.wstack.net/ws',
}

export enum ServerUrl {
  DEV0 = 'https://network-audit-metrics-api.gke1-west4.wsf-dev-0.wstack.net/network-audit-metrics/v1',
  PROD1 = 'https://api.weaveconnect.com/network-audit-metrics/v1',
}
